import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  get_list_transfer_failed,
  reverso_transfer_failed,
  search_transfer_failed,
} from "../../redux/actions";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {Spiner} from "../Spiner";

const TransferFailed = () => {
    const dispatch = useDispatch();
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [btnDisabledSearch, setBtnDisabledSearch] = useState(false);
    const [originId, setOriginId] = useState("");
    const lista = useSelector((state) => state.list_failed);
    const [loading,setLoading] = useState(true)

    // que siempre sea un array
  const dataList = Array.isArray(lista) ? lista : lista ? [lista] : [];
  useEffect(() => {
    fetchList();
   setTimeout(() => {
    setLoading(false)
   }, 1000);
  }, []);
  const fetchList = async () => {
    await dispatch(get_list_transfer_failed());
  };

  const search = async () => {
      if(!originId) return
    setBtnDisabledSearch(true);
    try {
      const response = await dispatch(
        search_transfer_failed({ origin_id: originId })
      );
      //console.log(response)
      if (response.status === 400) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.data?.msg,
        });
      }
    } catch (error) {
    } finally {
      setBtnDisabledSearch(false);
    }
  };
  const reversar = async (id) => {
    setBtnDisabled(true);
    try {
      const response = await dispatch(
        reverso_transfer_failed({ origin_id: id })
      );
      if (response.status === 200) {
        
        Swal.fire({
          icon: "success",
          title: "Operación exitosa",
        });
        await dispatch(get_list_transfer_failed());
      } else {
        //console.log(response);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response?.data?.msg,
        });
    
      }
    } catch (error) {
      console.log(error);
    } finally {
      setBtnDisabled(false);
    }
  };

  const confirmReverso = (id) => {
    Swal.fire({
      title: "¿Estás seguro de realizar esta acción?",
      text: `Se realizará el reverso del ID seleccionado (${id}). Por favor, confirma para continuar.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, reversar!",
    }).then((result) => {
      if (result.isConfirmed) {
        reversar(id);
      }
    });
  };
  return (
    <div className="container">
      <h5 className='ms-3 mb-4'>
        Transferencias Fallidas
      </h5>
      <div className="d-flex align-items-center mb-4 ms-3">
        <label htmlFor="" className="text-gray-600 ms-1  mr-2">
          Id de transacción
        </label>
        <input
          type="text"
          value={originId}
          onChange={(e) => setOriginId(e.target.value)}
          className='form-control' style={{width:300}}
          required
        />
        <button
          type="button"
          onClick={search}
          disabled={btnDisabledSearch}
          className='btn ms-2' style={{backgroundColor:"var(--naranja)",color:"white"}}
        >
          Buscar
        </button>
      </div>
{
    loading? <Spiner/>:( 
         /* Tabla de transferencias */
        <div className="bg-white rounded-lg p-4 overflow-x-auto ">
        <table className={`table `}>
          <thead className="table-info">
            <tr>
              <th >
                Id
              </th>
              <th className="pl-1 py-2 text-left text-xs uppercase text-gray-600">
                Fecha de operación
              </th>
              <th >
                CVU origen
              </th>
              <th >
                Cuit Origen
              </th>
              <th >
                Balance $
              </th>
              <th >
                Acción
              </th>
            </tr>
          </thead>
          <tbody >
            {dataList.length > 0 ? (
              dataList.map((el) => (
                <tr
                  key={el.origin_id}
               
                >
                  <td >
                    {el.origin_id}
                  </td>
                  <td >
                    {el.fecha?.replace("T", " ,")?.split(".")[0]}
                  </td>
                  <td >
                    {el.cvu_origen}
                  </td>
                  <td >
                    {el.cuit_origen}
                  </td>
                  <td >
                    {el.balance}
                  </td>
                  <td>
                    <button
                      disabled={btnDisabled}
                      onClick={() => confirmReverso(el.origin_id)}
                      style={{
                        border: "solid 1px var(--naranja)",
                    
                        fontSize: "14px",
                      }}
                      className=" btn btn-outline btn-lg"
                     
                    >
                      Reversar
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="6"
                  className="text-center py-4 text-gray-500 text-sm"
                >
                  No se encontraron transferencias fallidas.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    )
}
     
     
    </div>
  );
}

export default TransferFailed